'use client';
import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Link from 'next/link';

interface FAQItem {
  question: string;
  answer: React.ReactNode;
  answerText: string;
}

const faqItems: FAQItem[] = [
{
  question: 'Warum ist KI-Sichtbarkeit für Unternehmen heute entscheidend?',
  answerText: 'Immer mehr Menschen nutzen KI-Systeme als erste Orientierung bei der Suche nach Lösungen. Wenn Ihr Unternehmen dort nicht in den Empfehlungen erscheint, wird es in vielen Fällen gar nicht erst in die Auswahl einbezogen. Noch entscheidender: Was von der KI nicht vorgeschlagen wird, wird von Entscheidern häufig als riskant, veraltet oder irrelevant eingestuft. So entsteht ein impliziter Vertrauensnachteil. Früher konnten Werbung oder Messen mangelnde Online-Sichtbarkeit kompensieren. Heute ist der Entscheidungsprozess oft schon zu 70–80 % abgeschlossen, bevor ein Käufer überhaupt Kontakt zum Vertrieb aufnimmt. Wer in der KI-Suche nicht stattfindet, verliert faktisch seine Existenzgrundlage im Markt.',
  answer:
  <div className="space-y-3">
        <p>Immer mehr Menschen nutzen KI-Systeme als erste Orientierung bei der Suche nach Lösungen. Wenn Ihr Unternehmen dort nicht in den Empfehlungen erscheint, wird es in vielen Fällen gar nicht erst in die Auswahl einbezogen.</p>
        <p>Noch entscheidender: Was von der KI nicht vorgeschlagen wird, wird von Entscheidern häufig als riskant, veraltet oder irrelevant eingestuft. So entsteht ein impliziter Vertrauensnachteil.</p>
        <p>Früher konnten Werbung oder Messen mangelnde Online-Sichtbarkeit kompensieren. Heute ist der Entscheidungsprozess oft schon zu 70–80 % abgeschlossen, bevor ein Käufer überhaupt Kontakt zum Vertrieb aufnimmt. Wer in der KI-Suche nicht stattfindet, verliert faktisch seine Existenzgrundlage im Markt.</p>
        <p className="text-xs" style={{ color: 'rgba(148,163,184,0.6)' }}>¹ Bain & Company (2025): The AI-Search Paradigm: Why 'Visibility' is the New Market Entry Barrier.</p>
      </div>

},
{
  question: 'Warum verliert unsere Website Besucher, obwohl wir bei Google gut platziert sind?',
  answerText: 'Das Suchverhalten hat sich grundlegend geändert: Viele Kunden klicken nicht mehr auf Links, sondern lassen sich die Antwort direkt von einer KI oder Google anzeigen. Wir sorgen dafür, dass Ihr Unternehmen genau dort als die verlässliche Quelle genannt wird. So gewinnen Sie das Vertrauen des Kunden schon im ersten Satz der Antwort – noch bevor er Ihre Website besucht.',
  answer:
  <div className="space-y-3">
        <p>Das Suchverhalten hat sich grundlegend geändert: Viele Kunden klicken nicht mehr auf Links, sondern lassen sich die Antwort direkt von einer KI oder Google anzeigen.</p>
        <p>Wir sorgen dafür, dass Ihr Unternehmen genau dort als die verlässliche Quelle genannt wird. So gewinnen Sie das Vertrauen des Kunden schon im ersten Satz der Antwort – noch bevor er Ihre Website besucht.</p>
      </div>
},
{
  question: 'Wie bringen wir ChatGPT und Co. dazu, unser Unternehmen aktiv zu empfehlen?',
  answerText: 'KIs empfehlen Marken, denen sie Vertrauen und die sie als „Experten" im Netz wahrnehmen. Wir verknüpfen Ihr Unternehmen so geschickt mit Ihren Fachthemen, dass die Algorithmen Sie als die logische Wahl für Premium-Anfragen erkennen. Zudem brauchen sie klare, strukturierte Informationen im Hintergrund der Website, die sie ohne Missverständnisse auslesen können. Wir übersetzen Ihr Leistungsportfolio, Ihre Zielgruppen und Ihre offiziellen Kontaktdaten in eine digitale Sprache, die ChatGPT, Claude und Google auf Anhieb verstehen und empfehlen können.',
  answer:
  <div className="space-y-3">
        <p>KIs empfehlen Marken, denen sie Vertrauen und die sie als „Experten" im Netz wahrnehmen. Wir verknüpfen Ihr Unternehmen so geschickt mit Ihren Fachthemen, dass die Algorithmen Sie als die logische Wahl für Premium-Anfragen erkennen.</p>
        <p>Zudem brauchen sie klare, strukturierte Informationen im Hintergrund der Website, die sie ohne Missverständnisse auslesen können. Wir übersetzen Ihr Leistungsportfolio, Ihre Zielgruppen und Ihre offiziellen Kontaktdaten in eine digitale Sprache, die ChatGPT, Claude und Google auf Anhieb verstehen und empfehlen können.</p>
      </div>
},
{
  question: 'Was können wir tun, wenn die KI falsche oder veraltete Infos über uns verbreitet?',
  answerText: 'Das ist ein ernstes Risiko für Ihr Image. Wenn die KI Sie ignoriert oder falsche Fakten nennt, liegt das an einem unklaren digitalen Fußabdruck. Wir führen einen „digitalen Frühjahrsputz" durch, korrigieren die Quellen und stellen sicher, dass die KI nur noch die aktuellsten und positivsten Informationen über Sie verbreitet.',
  answer:
  <div className="space-y-3">
        <p>Das ist ein ernstes Risiko für Ihr Image. Wenn die KI Sie ignoriert oder falsche Fakten nennt, liegt das an einem unklaren digitalen Fußabdruck.</p>
        <p>Wir führen einen „digitalen Frühjahrsputz" durch, korrigieren die Quellen und stellen sicher, dass die KI nur noch die aktuellsten und positivsten Informationen über Sie verbreitet.</p>
      </div>
},
{
  question: 'Was ist der Unterschied zwischen SEO und AEO?',
  answerText: 'SEO basiert primär auf Keywords und Populärität – also darauf, welche Inhalte am besten auffindbar sind. Die Währung von SEO ist der Klick. Man kämpft um einen Platz unter den „Top 10 Links". AEO (Answer Engine Optimization) basiert auf Kontext und Autorität. Hier geht es darum, welche Unternehmen von KI-Systemen als vertrauenswürdige Lösung eingeordnet werden. Die Währung von AEO ist das Vertrauen des Sprachmodells (LLM) in die Korrektheit Ihrer Daten. Kurzgefasst: SEO optimiert für die Suchmaschine, AEO optimiert für die konkrete Empfehlung durch die KI.',
  answer:
  <div className="space-y-3">
        <p>SEO basiert primär auf Keywords und Populärität – also darauf, welche Inhalte am besten auffindbar sind. Die Währung von SEO ist der Klick. Man kämpft um einen Platz unter den „Top 10 Links".</p>
        <p>AEO (Answer Engine Optimization) basiert auf Kontext und Autorität. Hier geht es darum, welche Unternehmen von KI-Systemen als vertrauenswürdige Lösung eingeordnet werden. Die Währung von AEO ist das Vertrauen des Sprachmodells (LLM) in die Korrektheit Ihrer Daten.</p>
        <p>Kurzgefasst: SEO optimiert für die Suchmaschine, AEO optimiert für die konkrete Empfehlung durch die KI.</p>
      </div>

},
{
  question: 'Lohnt sich klassisches SEO überhaupt noch?',
  answerText: 'Ja, aber nur als Teil des Ganzen. SEO ist heute das Fundament, auf dem Ihre KI-Sichtbarkeit aufbaut. Wir kombinieren beides: Sie bleiben bei Google für Fachbegriffe findbar, während Sie gleichzeitig die Empfehlungen in ChatGPT und Perplexity dominieren.',
  answer:
  <div className="space-y-3">
        <p>Ja, aber nur als Teil des Ganzen. SEO ist heute das Fundament, auf dem Ihre KI-Sichtbarkeit aufbaut.</p>
        <p>Wir kombinieren beides: Sie bleiben bei Google für Fachbegriffe findbar, während Sie gleichzeitig die Empfehlungen in ChatGPT und Perplexity dominieren.</p>
      </div>
},
{
  question: 'Was versteht man unter Generative Engine Optimization (GEO)?',
  answerText: 'GEO beschreibt die strukturierte Aufbereitung von Informationen, damit sie von generativen KI-Systemen besser verstanden, verarbeitet und in Antworten berücksichtigt werden können. Während AEO beeinflusst, ob Sie genannt werden, beeinflusst GEO, wie Sie eingeordnet werden. Es geht um das Setzen valider digitaler Signale im gesamten Web, auf die sich die KI bei der Antwortgenerierung stützt.',
  answer:
  <div className="space-y-3">
        <p>GEO beschreibt die strukturierte Aufbereitung von Informationen, damit sie von generativen KI-Systemen besser verstanden, verarbeitet und in Antworten berücksichtigt werden können.</p>
        <p>Während AEO beeinflusst, ob Sie genannt werden, beeinflusst GEO, wie Sie eingeordnet werden. Es geht um das Setzen valider digitaler Signale im gesamten Web, auf die sich die KI bei der Antwortgenerierung stützt.</p>
      </div>

},
{
  question: 'Warum reichen klassische PR und Content-Marketing für KI-Systeme nicht mehr aus?',
  answerText: 'Klassische PR und Standard-Content sind für menschliche Leser optimiert, werden von KI-Systemen aber oft falsch interpretiert oder übersehen. GEO sorgt dafür, dass Ihre Inhalte die exakt mathematischen und semantischen Kriterien erfüllen – wie z. B. hohe Zitationsdichte und Entitäten-Verknüpfung –, die LLMs benötigen, um Sie als vertrauenswürdige Premium-Quelle einzustufen.',
  answer:
  <div className="space-y-3">
        <p>Klassische PR und Standard-Content sind für menschliche Leser optimiert, werden von KI-Systemen aber oft falsch interpretiert oder übersehen.</p>
        <p>GEO sorgt dafür, dass Ihre Inhalte die exakt mathematischen und semantischen Kriterien erfüllen – wie z. B. hohe Zitationsdichte und Entitäten-Verknüpfung –, die LLMs benötigen, um Sie als vertrauenswürdige Premium-Quelle einzustufen.</p>
      </div>
},
{
  question: 'Berücksichtigt GEO auch den Datenschutz (DSGVO) unseres Unternehmens?',
  answerText: 'Ja, absolut. Bei der Generative Engine Optimization wird ausschließlich Ihr öffentlicher digitaler Fußabdruck – also frei zugängliche Daten, Fachartikel, Zitate und Plattform-Einträge – für die KI-Systeme optimiert. Interne Firmendaten oder sensible Kundendaten bleiben vollkommen unberührt und geschützt.',
  answer:
  <div className="space-y-3">
        <p>Ja, absolut. Bei der Generative Engine Optimization wird ausschließlich Ihr öffentlicher digitaler Fußabdruck – also frei zugängliche Daten, Fachartikel, Zitate und Plattform-Einträge – für die KI-Systeme optimiert.</p>
        <p>Interne Firmendaten oder sensible Kundendaten bleiben vollkommen unberührt und geschützt.</p>
      </div>
},
{
  question: 'Kann man KI-Antworten wirklich beeinflussen?',
  answerText: 'Ja – und genau hier entsteht aktuell ein klarer Wettbewerbsvorteil. KI-Systeme greifen auf öffentlich verfügbare Informationen zurück und bevorzugen Quellen, die konsistent, relevant und vertrauenswürdig erscheinen. Durch gezieltes Authority Building und das Setzen von Experten-Signalen sorgen wir dafür, dass die KI Ihr Unternehmen als „Top-of-Mind"-Lösung für spezifische Probleme einstuft.',
  answer:
  <div className="space-y-3">
        <p>Ja – und genau hier entsteht aktuell ein klarer Wettbewerbsvorteil. KI-Systeme greifen auf öffentlich verfügbare Informationen zurück und bevorzugen Quellen, die konsistent, relevant und vertrauenswürdig erscheinen.</p>
        <p>Durch gezieltes Authority Building und das Setzen von Experten-Signalen sorgen wir dafür, dass die KI Ihr Unternehmen als „Top-of-Mind"-Lösung für spezifische Probleme einstuft.</p>
      </div>

},
{
  question: 'Warum ist KI-Sichtbarkeit gerade für B2B-Marktführer so entscheidend?',
  answerText: 'Wenn ein Entscheider eine KI fragt: „Wer ist der beste Anbieter für mein Projekt?" und Sie tauchen dort nicht auf, existieren Sie für diesen Kunden nicht. Wir sichern Ihren Platz in diesen Antworten, bevor die Konkurrenz den Raum besetzt. Das ist digitaler Vorsprung, der sich direkt in Marktanteilen auszahlt. Keine KI-Sichtbarkeit zu haben bedeutet, den wichtigsten digitalen Vertriebskanal der Zukunft komplett der Konkurrenz zu überlassen.',
  answer:
  <div className="space-y-3">
        <p>Wenn ein Entscheider eine KI fragt: „Wer ist der beste Anbieter für mein Projekt?" und Sie tauchen dort nicht auf, existieren Sie für diesen Kunden nicht.</p>
        <p>Wir sichern Ihren Platz in diesen Antworten, bevor die Konkurrenz den Raum besetzt. Das ist digitaler Vorsprung, der sich direkt in Marktanteilen auszahlt. Keine KI-Sichtbarkeit zu haben bedeutet, den wichtigsten digitalen Vertriebskanal der Zukunft komplett der Konkurrenz zu überlassen.</p>
      </div>
},
{
  question: 'Was ist das AI Visibility Audit?',
  answerText: 'Im Rahmen des Audits führen wir eine mehrdimensionale Multivektor-Analyse durch. Wir simulieren systematisch eine große Bandbreite an Anfragen innerhalb führender Sprachmodelle. So identifizieren wir präzise, warum die KI eventuell Ihre Konkurrenz bevorzugt und wo bei Ihnen aktuell strukturelle Lücken („Blind Spots") in der digitalen Wahrnehmung bestehen. Die Ergebnisse bilden die Grundlage für eine individuelle Strategie.',
  answer:
  <div className="space-y-3">
        <p>Im Rahmen des Audits führen wir eine mehrdimensionale Multivektor-Analyse durch. Wir simulieren systematisch eine große Bandbreite an Anfragen innerhalb führender Sprachmodelle.</p>
        <p>So identifizieren wir präzise, warum die KI eventuell Ihre Konkurrenz bevorzugt und wo bei Ihnen aktuell strukturelle Lücken („Blind Spots") in der digitalen Wahrnehmung bestehen. Die Ergebnisse bilden die Grundlage für eine individuelle Strategie.</p>
      </div>

},
{
  question: 'Wie schnell sind erste Ergebnisse in der KI-Sichtbarkeit spürbar?',
  answerText: 'KI-Systeme mit Echtzeit-Webzugriff reagieren oft deutlich schneller als klassisches SEO. Erste spürbare Veränderungen können bereits nach 14–16 Tagen eintreten. Unser strukturierter 4-Phasen-Prozess ist darauf ausgelegt, schnell die richtigen Signale zu setzen und gleichzeitig ein nachhaltiges Fundament für Ihren langfristigen Erfolg zu legen.',
  answer:
  <div className="space-y-3">
        <p>KI-Systeme mit Echtzeit-Webzugriff reagieren oft deutlich schneller als klassisches SEO. Erste spürbare Veränderungen können bereits nach 14–16 Tagen eintreten.</p>
        <p>Unser strukturierter 4-Phasen-Prozess ist darauf ausgelegt, schnell die richtigen Signale zu setzen und gleichzeitig ein nachhaltiges Fundament für Ihren langfristigen Erfolg zu legen.</p>
      </div>
},
{
  question: 'Führt KI-Sichtbarkeit wirklich zu mehr Abschlüssen?',
  answerText: 'Ja. Ein Kunde, der über eine KI-Empfehlung kommt, hat bereits ein hohes Grundvertrauen in Sie – die KI hat die Vorauswahl für ihn getroffen. Das führt zu kürzeren Verkaufsgesprächen und einer deutlich höheren Abschlussquote. Unsere Partner verzeichnen Abschlussquoten von bis zu 91 %, da der Kunde bereits von Ihrer Expertise überzeugt ist und nicht mehr kommt, um sich zu informieren, sondern um zu kaufen.',
  answer:
  <div className="space-y-3">
        <p>Ja. Ein Kunde, der über eine KI-Empfehlung kommt, hat bereits ein hohes Grundvertrauen in Sie – die KI hat die Vorauswahl für ihn getroffen.</p>
        <p>Das führt zu kürzeren Verkaufsgesprächen und einer deutlich höheren Abschlussquote. Unsere Partner verzeichnen Abschlussquoten von bis zu 91 %, da der Kunde bereits von Ihrer Expertise überzeugt ist und nicht mehr kommt, um sich zu informieren, sondern um zu kaufen.</p>
      </div>
},
{
  question: 'Warum lohnt sich eine langfristige Zusammenarbeit?',
  answerText: 'Die KI-Welt ändert sich wöchentlich. Was heute funktioniert, kann morgen durch ein Update veraltet sein. Wir begleiten Sie dauerhaft, bauen Ihre Autorität durch Fachartikel und Communities kontinuierlich aus und schützen Ihre Spitzenposition gegen Wettbewerber.',
  answer:
  <div className="space-y-3">
        <p>Die KI-Welt ändert sich wöchentlich. Was heute funktioniert, kann morgen durch ein Update veraltet sein.</p>
        <p>Wir begleiten Sie dauerhaft, bauen Ihre Autorität durch Fachartikel und Communities kontinuierlich aus und schützen Ihre Spitzenposition gegen Wettbewerber.</p>
      </div>
},
{
  question: 'Wie viel Zeit muss mein Team für die Zusammenarbeit einplanen?',
  answerText: 'Fast keine. Unser Service ist „Done-for-You". Nach einem ersten Strategiegespräch übernehmen wir die komplette Arbeit: Analyse, Texte, technische Optimierung und Steuerung der Signale im Netz. Sie konzentrieren sich auf Ihr Geschäft, wir auf Ihre Sichtbarkeit.',
  answer:
  <div className="space-y-3">
        <p>Fast keine. Unser Service ist „Done-for-You". Nach einem ersten Strategiegespräch übernehmen wir die komplette Arbeit: Analyse, Texte, technische Optimierung und Steuerung der Signale im Netz.</p>
        <p>Sie konzentrieren sich auf Ihr Geschäft, wir auf Ihre Sichtbarkeit.</p>
      </div>
},
{
  question: 'Warum in.versum?',
  answerText: 'Wir verbinden journalistische Präzision mit fundierter Erfahrung im Aufbau digitaler Reichweiten im dreistelligen Millionenbereich. Hinter in.versum stehen zwei Spezialisten, die sowohl die Mechanismen klassischer Medien als auch die Logik moderner KI-Systeme verstehen.',
  answer:
  <div className="space-y-4">
        <p>Wir verbinden journalistische Präzision mit fundierter Erfahrung im Aufbau digitaler Reichweiten im dreistelligen Millionenbereich. Hinter in.versum stehen zwei Spezialisten, die sowohl die Mechanismen klassischer Medien als auch die Logik moderner KI-Systeme verstehen.</p>
        <div className="space-y-3 pl-4 border-l" style={{ borderColor: 'rgba(99,102,241,0.3)' }}>
          <div>
            <p className="font-semibold text-white mb-1">Strategische KI-Architektur</p>
            <p>Fundiert durch Erfahrung in der Unternehmenskommunikation und die Zusammenarbeit mit führenden Fachverlagen.</p>
          </div>
          <div>
            <p className="font-semibold text-white mb-1">Radikale Sichtbarkeit</p>
            <p>Expertise aus über 450 Millionen generierten Views. Wir wissen nicht nur, wie Inhalte entstehen, sondern vor allem, wie sie Resonanz erzeugen und von KI-Systemen als relevante Lösung interpretiert werden.</p>
          </div>
        </div>
      </div>

},
{
  question: 'Wie läuft die Zusammenarbeit mit in.versum ab?',
  answerText: 'in.versum ist ein vollständiger Done-For-You-Service. Sie müssen nichts selbst umsetzen, schreiben oder koordinieren. Die Zusammenarbeit beginnt mit einem strukturierten Audit Ihrer aktuellen KI-Präsenz. Darauf aufbauend übernehmen wir die gesamte Umsetzung: Strategie, Texte, technische Optimierung, Authority Building und die kontinuierliche Steuerung aller Signale im Netz. Von der ersten Aktivierung (Visibility Activation) bis zum langfristigen Schutz Ihrer Spitzenposition (Authority Shield) – alles liegt in unseren Händen. Absolute Diskretion ist dabei unser Fundament.',
  answer:
  <div className="space-y-3">
        <p>in.versum ist ein vollständiger <strong className="text-white">Done-For-You-Service</strong>. Sie müssen nichts selbst umsetzen, schreiben oder koordinieren.</p>
        <p>Die Zusammenarbeit beginnt mit einem strukturierten Audit Ihrer aktuellen KI-Präsenz. Darauf aufbauend übernehmen wir die <strong className="text-white">gesamte Umsetzung</strong>: Strategie, Texte, technische Optimierung, Authority Building und die kontinuierliche Steuerung aller Signale im Netz.</p>
        <p>Von der ersten Aktivierung (Visibility Activation) bis zum langfristigen Schutz Ihrer Spitzenposition (Authority Shield) – alles liegt in unseren Händen. Absolute Diskretion ist dabei unser Fundament.</p>
      </div>
}];


function FAQAccordionItem({ item, index }: {item: FAQItem;index: number;}) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="group"
      style={{
        borderBottom: '1px solid rgba(99,102,241,0.12)'
      }}>

      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-start justify-between gap-4 py-6 text-left"
        aria-expanded={open}>

        <div className="flex items-start gap-4">
          <span
            className="flex-shrink-0 text-xs font-mono mt-0.5"
            style={{ color: 'rgba(99,102,241,0.5)', minWidth: '1.5rem' }}>

            {String(index + 1).padStart(2, '0')}
          </span>
          <span
            className="text-base font-semibold leading-snug transition-colors duration-200"
            style={{ color: open ? '#fff' : 'rgba(226,232,240,0.9)' }}>

            {item.question}
          </span>
        </div>
        <span
          className="flex-shrink-0 mt-0.5 transition-transform duration-300"
          style={{
            transform: open ? 'rotate(45deg)' : 'rotate(0deg)',
            color: open ? '#818CF8' : 'rgba(148,163,184,0.5)'
          }}>

          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
            <path d="M12 5v14M5 12h14" />
          </svg>
        </span>
      </button>

      <div
        className="overflow-hidden transition-all duration-300"
        style={{
          maxHeight: open ? '600px' : '0px',
          opacity: open ? 1 : 0
        }}>

        <div
          className="pb-6 pl-10 pr-2 text-sm leading-relaxed"
          style={{ color: 'rgba(148,163,184,0.85)' }}>

          {item.answer}
        </div>
      </div>
    </div>);

}

export default function FAQPage() {
  const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || 'https://in-versum.de';

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: baseUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'FAQ',
        item: `${baseUrl}/faq`,
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      {/* Background */}
      <div className="nebula-bg">
        <img
          src="/assets/images/HD_wallpaper_Galaxy_Stars_Space_Blue_Black-1774114922765.jpeg"
          alt="Nebula Hintergrund"
          aria-hidden="true" />

        <div className="nebula-overlay" />
      </div>
      <div className="noise-overlay" aria-hidden="true" />

      <Header />

      <main className="content-layer min-h-screen">
        {/* Hero */}
        <section className="pt-32 pb-16 px-5">
          <div className="max-w-3xl mx-auto">
            <div className="mb-3 flex items-center gap-2">
              <Link
                href="/"
                className="text-xs font-medium transition-colors duration-200"
                style={{ color: 'rgba(99,102,241,0.7)' }}>

                Home
              </Link>
              <span style={{ color: 'rgba(99,102,241,0.3)' }}>/</span>
              <span className="text-xs" style={{ color: 'rgba(148,163,184,0.5)' }}>FAQ</span>
            </div>

            <div
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium mb-6"
              style={{
                background: 'rgba(99,102,241,0.08)',
                border: '1px solid rgba(99,102,241,0.2)',
                color: '#818CF8'
              }}>

              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
              Häufig gestellte Fragen
            </div>

            <h1
              className="font-display font-bold leading-tight mb-4"
              style={{
                fontSize: 'clamp(2rem, 5vw, 3rem)',
                letterSpacing: '-0.03em',
                background: 'linear-gradient(135deg, #fff 0%, rgba(148,163,184,0.8) 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>FAQ


            </h1>
            <p
              className="text-base leading-relaxed max-w-xl"
              style={{ color: 'rgba(148,163,184,0.75)' }}>

              Antworten auf die wichtigsten Fragen rund um KI-Sichtbarkeit, AEO, GEO und die Zusammenarbeit mit in.versum.
            </p>
          </div>
        </section>

        {/* Divider */}
        <div className="max-w-3xl mx-auto px-5">
          <div style={{ height: '1px', background: 'linear-gradient(to right, transparent, rgba(99,102,241,0.3), transparent)' }} />
        </div>

        {/* FAQ Accordion */}
        <section className="py-10 px-5">
          <div className="max-w-3xl mx-auto">
            {faqItems.map((item, index) =>
            <FAQAccordionItem key={index} item={item} index={index} />
            )}
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 px-5">
          <div className="max-w-3xl mx-auto">
            <div
              className="rounded-2xl p-8 text-center"
              style={{
                background: 'rgba(99,102,241,0.06)',
                border: '1px solid rgba(99,102,241,0.18)'
              }}>

              <p
                className="text-sm font-medium mb-2"
                style={{ color: '#818CF8' }}>

                Noch offene Fragen?
              </p>
              <h2
                className="font-display font-bold text-xl mb-4"
                style={{ color: '#fff', letterSpacing: '-0.02em' }}>Schreiben Sie uns jederzeit gerne.


              </h2>
              <p
                className="text-sm mb-6 max-w-sm mx-auto"
                style={{ color: 'rgba(148,163,184,0.7)' }}>

                Wir beantworten Ihre individuellen Fragen persönlich und diskret.
              </p>
            </div>
          </div>
        </section>
      </main>

      <div className="content-layer">
        <Footer />
      </div>
    </>);

}
